import {
  Box,
  Flex,
  Image,
  Text,
  VStack,
  Wrap,
  WrapItem,
  useBreakpointValue,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  isEmptyOrNull,
  isNotEmptyOrNull,
  urlString,
} from "../../../utils/common-utils";
import {
  backUpObjectCreation,
  onClickSubtopic,
  selectedSubtopicSkeleton,
  showAccordionSubtopicContent,
} from "../../../utils/accordion/accordionHelper";

import AccordionTaskSkeleton from "../SkeletonViews/AccordionTaskSkeleton";
import AskDoubtAccordion from "../accordionComponents/AskDoubtAccordion";
import CustomAssessmentAccordion from "../accordionComponents/CustomAssessmentAccordion";
import ExperientialAccordion from "../accordionComponents/ExperientialAccordion";
import ListAccordionView from "../accordionComponents/ListAccordionView";
import ProgressStatus from "../progressStatus/progressStatus";
import RESOURCES from "../../../resourses/RESOURCES";
import SelfLearnButtonsAccordion from "../accordionComponents/SelfLearnButtonsAccordion";
import Skeleton from "react-loading-skeleton";
import { SubjectSelectorStyles } from "./SubjectSelectorStyles";
import SubtopicsAccordion from "../accordionComponents/SubtopicsAccordion";
import { getTaskProgressData } from "../../../network/LearnApiService";
import { useLocation, useNavigate } from "@remix-run/react";
import { useRoot } from "../../../context/RootContext";
import useStateRef from "react-usestateref";
import { useTutor } from "../../../context/AiTutorContext";
import { StorageService } from "../../../utils/StorageUtils";
import { usePractice } from "../../../context/PracticeContext";

const SubjectSelector = ({
  topics,
  setSelectedSubtopic,
  selectedSubtopic,
  filterRole,
  isLearn = false,
  mode,
  onTopicSelector,
  isSideNav,
  latestTasksList,
  onClickFromSubjectSelector,
  onSelfLearnButtonClick,
  customAssessmentTopicsUnlockedList,
}) => {
  let [subtopics, setSubtopics] = useState([]);
  let [
    selectedSubtopicDetails,
    setSelectedSubTopicDetails,
    selectedSubtopicDetailsRef,
  ] = useStateRef("");
  let [
    selectedProficientLevel,
    setSelectedProficientLevel,
    selectedProficientLevelRef,
  ] = useStateRef("");

  const {
    setSubtopicId,
    setSubtopicMasterUuid,
    setTopicId,
    setTopicMasterUuid,
    setTopic,
    setSubTopic,
    setJourneyId,
    setOnNextItemSelected,
    setIsChapterEndAssessment,
    setChapterEndAssessmentType,
    callSameSubTopicAgain,
    setCallSameSubTopicAgain,
    setSelectedExperiential,
  } = useTutor();
  const {
    setSubTopicName,
    selectedIndex,
    isTutor,
    setTaskId,
    isStandaloneWithSubjectMapping,
    setTaskType,
    isUpdatesDisplayed,
    setIsUpdatesDisplayed,
    toggleLearnDrawer,
    isSelfLearnButtonClick,
    isDiscussFlow,
    isStandalone,
    isRedirectObjectInserted,
    setReviewScreen,
  } = useRoot();

  const navigate = useNavigate();
  const location = useLocation();

  const [openSubtopicId, setOpenSubtopicId] = useState(null);
  const [updatesSubtopicId, setUpdatesSubtopicId] = useState(null);
  const [subTopicTaskProgress, setSubTopicTaskProgress] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdvancedChapterEndAssessment, setIsAdvancedChapterEndAssessment] =
    useState(false);
  const [
    isProficientChapterEndAssessment,
    setIsProficientChapterEndAssessment,
  ] = useState(false);
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
    lg: false,
  });

  const onClick = (
    taskType,
    ChapterEndAssessment,
    index,
    actualTaskType
    // selfLearnButtonClick = false
  ) => {
    // console.log("TASK TYPE", taskType);
    // console.log("chapterEndAssessment", ChapterEndAssessment); // need for future purpose
    // console.log("INDEX", index);
    // else {
    // setDisplayedQues([]);
    // if (selfLearnButtonClick) {
    //   resetPractice(selfLearnButtonClick, isSideNav);
    // }
    onSelectSubTopic(
      selectedSubtopicDetailsRef.current,
      //true,
      ChapterEndAssessment,
      taskType,
      selectedProficientLevelRef.current,
      index,
      actualTaskType
      // selfLearnButtonClick
    );
    //}
  };

  const onSelectSubTopic = (
    selectedSubtopic,
    chapterEndAssessment,
    taskType,
    proficiencyLevel,
    index,
    actualTaskType
    // selfLearnButtonClick
  ) => {
    //console.log("SELECTED SUBTOPICSSS", selectedSubtopic); //need for future purpose
    let item = {};
    // if(location?.)
    // if (location?.pathname?.includes("/review") && selfLearnButtonClick) {
    //   navigate(-1);
    // }
    if (
      subTopicTaskProgress?.[index]?.taskStatus === "completed" ||
      isSideNav
    ) {
      let localReviewJourneyId = StorageService.getItem("ReviewJourneyId");
      if (
        localReviewJourneyId !== subTopicTaskProgress?.[index]?.journeyId ||
        isDiscussFlow
      ) {
        StorageService.setItem(
          "ReviewJourneyId",
          subTopicTaskProgress?.[index]?.journeyId
        );
        StorageService.setItem(
          "topicName",
          subTopicTaskProgress?.[index]?.taskAttributes?.topicName ||
            topics?.topic?.topicInfo?.name ||
            ""
        );
        StorageService.setItem(
          "subjectName",
          subTopicTaskProgress?.[index]?.taskAttributes?.subjectName ||
            topics?.topic?.topicInfo?.subject_name ||
            ""
        );
        StorageService.setItem(
          "subTopicName",
          subTopicTaskProgress?.[index]?.taskAttributes?.subtopicName ||
            selectedSubtopic?.subtopicInfo?.name ||
            ""
        );
        let subjectMasterUuid =
          subTopicTaskProgress?.[index]?.subjectId ||
          topics?.subject?.subjectMasterUuid;
        let topicMasterUuid =
          subTopicTaskProgress?.[index]?.taskAttributes?.topicMasterUuid ||
          topics?.topic?.topicMasterUuid;
        StorageService.setItem("subjectMasterUUid", subjectMasterUuid);
        StorageService.setItem("topicMasterUUid", topicMasterUuid);
        setReviewScreen(true);
        if (isSideNav) {
          onClickFromSubjectSelector();
        } // for learn side nav
        navigate(`${urlString}/review`, {
          state: {
            // journeyId: subTopicTaskProgress?.[index]?.journeyId,
            subjectMasterUuid: subjectMasterUuid,
            topicMasterUuid: topicMasterUuid,
          },
        });
      } else {
        // better to display a toast here
        if (isSideNav) {
          toggleLearnDrawer();
        }
        console.log("You have already reviewed this task");
      }
    } else {
      //CHAPTER END ASSESSMENT CASE
      if (chapterEndAssessment) {
        //Chapter End SelfLearn
        if (index === -1) {
          if (isNotEmptyOrNull(taskType) && taskType === "advanced") {
            setChapterEndAssessmentType(taskType);
          } else {
            setChapterEndAssessmentType("proficient");
          }
          let tempItem = subTopicTaskProgress?.find(
            (task) =>
              task?.taskStatus !== "completed" &&
              task?.createdBy === "student" &&
              task?.taskType === actualTaskType &&
              isEmptyOrNull(task?.levelUpReference) &&
              task?.taskAttributes?.proficiencyLevel === taskType
          );
          if (tempItem) {
            item = tempItem;
          }
        } else {
          //For Teacher Assigned Tasks, fetching based on index
          item = subTopicTaskProgress?.[index];
        }
      }
      //NORMAL TASKS
      else {
        if (taskType !== "Self Learn") {
          item = subTopicTaskProgress?.[index];
        } else {
          if (
            index !== -1 &&
            !(taskType === "ExperientialTask") &&
            !(taskType === "Experiential")
          ) {
            item = subTopicTaskProgress?.[index];
          } else if (index === -1) {
            let tempItem = subTopicTaskProgress.find(
              (task) =>
                task?.taskStatus !== "completed" &&
                task?.createdBy === "student" &&
                task?.taskType === actualTaskType &&
                isEmptyOrNull(task?.levelUpReference)
            );
            if (tempItem) {
              item = tempItem;
            }
          }
        }
      }

      // if (isSideNav) {
      //   onSelfLearnButtonClick();
      // }

      if (taskType === "ExperientialTask") {
        setTaskType("experientialLearning");
        actualTaskType = "experientialLearning";
        setSelectedExperiential(item || selectedSubtopicDetailsRef.current);
      }

      if (taskType === "Experiential") {
        setTaskType("experientialLearning");
        actualTaskType = "experientialLearning";
        setSelectedExperiential(item || selectedSubtopicDetailsRef.current);
      }

      if (isNotEmptyOrNull(chapterEndAssessment)) {
        setIsChapterEndAssessment(chapterEndAssessment);
      } else {
        setIsChapterEndAssessment(false);
      }
      setOnNextItemSelected(true);

      if (item?.taskStatus !== "completed") {
        setJourneyId(item?.journeyId);
        setTaskId(item?._id);
      }

      let transformedSubtopic = selectedSubtopicSkeleton(
        selectedSubtopic,
        topics,
        actualTaskType
      );
      let transformedSelectedSubtopic = isNotEmptyOrNull(item)
        ? item
        : transformedSubtopic;
      setSelectedSubtopic(transformedSelectedSubtopic);
      if (isTutor) {
        setTopicId(topics?.id);
        setTopic(topics?.name);
        setTopicMasterUuid(topics?.masterId ? topics?.masterId : "");
      } else {
        setTopicId(item?.topicId || topics?.topic?.topicId);
        setTopic(
          item?.taskAttributes?.topicName || topics?.topic?.topicInfo?.name
        );
        setTopicMasterUuid(
          item?.taskAttributes?.topicMasterUuid ||
            topics?.topic?.topicMasterUuid ||
            ""
        );
      }
      // console.log("selectedSubtopic", selectedSubtopic);
      // console.log("topics", topics);
      onTopicSelector(transformedSelectedSubtopic, topics);

      setSubtopicId(
        item?.taskAttributes?.subtopicId || selectedSubtopic.subtopicId || ""
      );
      setSubtopicMasterUuid(
        item?.taskAttributes?.subtopicMasterUuid ||
          selectedSubtopic?.subtopicMasterUuid ||
          ""
      );
      setSubTopic(
        item?.taskAttributes?.subtopicName ||
          selectedSubtopic?.subtopicInfo?.name ||
          ""
      );
      setSubTopicName(
        item?.taskAttributes?.subtopicName ||
          selectedSubtopic?.subtopicInfo?.name ||
          ""
      );
      setCallSameSubTopicAgain(!callSameSubTopicAgain);

      let backUpObject = backUpObjectCreation(transformedSelectedSubtopic);
      if (
        !isStandalone &&
        !isStandaloneWithSubjectMapping &&
        !isRedirectObjectInserted
      ) {
        StorageService.setItem("backUpObject", backUpObject);
      }
      navigate(`${urlString}/practice`, {
        state: {
          selectedSubTopic: transformedSelectedSubtopic,
          selectedTopic: topics,
          actualTaskType: actualTaskType,
        },
      });
    }
  };

  const filterTutorSubTopics = () => {
    let subTopicsList = topics?.subtopic;
    return subTopicsList;
  };

  //getting the taskprogress data of each subtopic
  const handleTaskProgressData = async (
    topicId,
    subTopicId,
    limit = 5,
    offset = 0,
    isChapterEndAssessment = false,
    isCustomAssessment = false,
    isAdvanced = false,
    isProficient = false,
    isPrerequisite = false
  ) => {
    setIsLoading(true);

    try {
      let subTopicTaskProgress = await getTaskProgressData(
        topicId,
        subTopicId,
        limit,
        offset,
        isChapterEndAssessment,
        isCustomAssessment,
        isPrerequisite
      );

      //console.log("TASK PROGRESS DATA", subTopicTaskProgress); //need for future purpose

      if (isSideNav) {
        subTopicTaskProgress = subTopicTaskProgress?.filter(
          (item) => !(item?.taskStatus === "notStarted")
        );
      }

      //FILTERING THE CHAPTER END ASSESSMENT TASKS BASED ON PROFICIENCY LEVEL
      if (isChapterEndAssessment && isAdvanced) {
        subTopicTaskProgress = subTopicTaskProgress?.filter(
          (item) => item?.taskAttributes?.proficiencyLevel === "advanced"
        );
      } else if (isChapterEndAssessment && isProficient) {
        subTopicTaskProgress = subTopicTaskProgress?.filter(
          (item) => item?.taskAttributes?.proficiencyLevel === "proficient"
        );
      }

      setSubTopicTaskProgress(subTopicTaskProgress);
    } catch (error) {
      console.error("Error fetching task progress data", error);
    } finally {
      setIsLoading(false);
    }
  };

  //Function to call the handleTaskProgressData function for different subtopic types
  const triggerTaskProgressData = (
    isunlocked = false,
    isExperientialLearning = false,
    isChapterEndAssessment = false,
    isCustomAssessment = false,
    subtopicId,
    isAdvanced = false,
    isProficient = false,
    isPrerequisite = false
  ) => {
    if (isunlocked) {
      if (
        !isChapterEndAssessment &&
        !isCustomAssessment &&
        !isPrerequisite &&
        !isExperientialLearning
      ) {
        handleTaskProgressData(
          topics?.topic?.topicId,
          subtopicId,
          10,
          0,
          isChapterEndAssessment,
          isCustomAssessment,
          isAdvanced,
          isProficient,
          isPrerequisite
        );
      } else {
        handleTaskProgressData(
          topics?.topic?.topicId,
          "",
          10,
          0,
          isChapterEndAssessment,
          isCustomAssessment,
          isAdvanced,
          isProficient,
          isPrerequisite
        );
      }
    }
  };

  useEffect(() => {
    let filteredSubtopics;
    if (!isTutor) {
      let topic_features = topics?.topic?.topicInfo?.topic_features;
      filteredSubtopics = topics?.subtopics?.map((subtopic) => ({
        ...subtopic,
        // isExperiential: false,
        // isChapterEndAssessment: false,
        // isCustomAssessment: false,
        // isAdvanced: false,
        // isProficient: false,
      }));

      let chapterEndAssessmentSubtopic = topics?.topic?.chapterEndAssessment;
      let experientialLearningSubtopic = topics?.topic?.experientialLearning;
      let customAssessmentSubtopic = topics?.topic?.customAssessment;
      let prerequisiteSubtopic = topics?.topic?.learnPrerequisite;

      //Prerequisite addition
      if (
        isNotEmptyOrNull(prerequisiteSubtopic) &&
        isNotEmptyOrNull(topic_features)
          ? topic_features?.Prerequisite?.is_enabled
          : true
      ) {
        filteredSubtopics = [
          {
            learnPrerequisite: prerequisiteSubtopic,
            learnPrerequisiteCount: topics?.topic?.learnPrerequisiteCount,
            locked: false,
            isPrerequisite: true,
          },
          ...filteredSubtopics,
        ];
      }

      //experiential learning be added
      // if (isNotEmptyOrNull(experientialLearningSubtopic)) {
      //   if (
      //     experientialLearningSubtopic?.locked === false &&
      //     !isSideNav &&
      //     isNotEmptyOrNull(topic_features)
      //       ? topic_features?.["Experiential Learning"]?.is_enabled
      //       : true
      //   ) {
      //     filteredSubtopics = [
      //       ...filteredSubtopics,
      //       ...experientialLearningSubtopic?.data.map((subtopic) => ({
      //         ...subtopic,
      //         isExperiential: true,
      //         locked: false,
      //       })),
      //     ];
      //   }
      // }

      //Creating two same objects for chapter end assessment where in one isAdvanced is true
      //and other isProficient is true
      if (
        isNotEmptyOrNull(topic_features)
          ? topic_features?.["Chapter-End Assessment"]?.is_enabled
          : true
      ) {
        filteredSubtopics = [
          ...filteredSubtopics,
          {
            ...chapterEndAssessmentSubtopic,
            // isExperiential: false,
            isChapterEndAssessment: true,
            // isCustomAssessment: false,
            // isAdvanced: false,
            isProficient: true,
          },
        ];
      }

      if (
        isNotEmptyOrNull(topic_features)
          ? topic_features?.Advanced?.is_enabled
          : true
      ) {
        filteredSubtopics = [
          ...filteredSubtopics,

          {
            ...chapterEndAssessmentSubtopic,
            //isExperiential: false,
            isChapterEndAssessment: true,
            //isCustomAssessment: false,
            isAdvanced: true,
            //isProficient: false,
          },
        ];
      }

      //custom assessment object being added
      const topicMasterUuid = topics?.topic?.topicMasterUuid;

      if (
        isNotEmptyOrNull(topicMasterUuid) &&
        customAssessmentTopicsUnlockedList?.includes(topicMasterUuid)
      ) {
        filteredSubtopics = [
          ...filteredSubtopics,
          {
            ...customAssessmentSubtopic,
            // isExperiential: false,
            // isChapterEndAssessment: false,
            isCustomAssessment: true,
            locked: false,
            // isAdvanced: false,
            // isProficient: false,
          },
        ];
      }
      console.log("Filter", filteredSubtopics); //Need this for future purposes
    }
    if (isTutor || isStandaloneWithSubjectMapping) {
      filteredSubtopics = filterTutorSubTopics();
    }
    setSubtopics(filteredSubtopics.filter((item) => isNotEmptyOrNull(item)));
  }, [topics, isLearn]);

  //opening the subtopics accordion view
  const handleAccordionToggle = (
    subtopicId,
    subTopicType,
    isAdvanced = false,
    isProficient = false
  ) => {
    setSelectedSubTopicDetails("");

    //resetting the flags for chapter end assessment
    if (isAdvanced) {
      setIsProficientChapterEndAssessment(false);
    } else if (isProficient) {
      setIsAdvancedChapterEndAssessment(false);
    } else {
      setIsAdvancedChapterEndAssessment(false);
      setIsProficientChapterEndAssessment(false);
    }
    //setting the subtopic ids
    if (subTopicType === "Prerequisite") {
      setOpenSubtopicId((prevId) =>
        prevId === subtopicId ? null : subtopicId
      );
    } else if (subTopicType !== "chapterEndAssessment") {
      // all type of topics except chapter end assessment
      setOpenSubtopicId((prevId) =>
        prevId === subtopicId ? null : subtopicId
      );
    } else if (
      subTopicType === "chapterEndAssessment" &&
      ((isAdvanced && isAdvancedChapterEndAssessment) ||
        (isProficient && isProficientChapterEndAssessment))
    ) {
      // chapter end assessment type but the subtopic is open and when the same the subtopic is clicked again
      // the subtopic closes
      setOpenSubtopicId((prevId) =>
        prevId === subtopicId ? null : subtopicId
      );
    } else {
      //chapter end assessment type and the subtopic is toggled between advanced and proficient
      setOpenSubtopicId(subtopicId);
    }

    if (subTopicType === "subtopic") {
      setSelectedSubTopicDetails(
        subtopics?.find((subtopic) => subtopic?.subtopicId === subtopicId)
      );
    } else if (subTopicType === "experientialLearning") {
      setSelectedSubTopicDetails(
        subtopics?.find((subtopic) => subtopic?.id === subtopicId)
      );
    } else if (subTopicType === "chapterEndAssessment") {
      //for the case of the advanced chapter end assessment
      if (isAdvanced) {
        setSelectedSubTopicDetails(
          subtopics?.find(
            (subtopic) =>
              subtopic?.isChapterEndAssessment === true &&
              subtopic?.isAdvanced === true
          )
        );
        setIsAdvancedChapterEndAssessment(true);
      } else {
        //for the case of the proficient chapter end assessment
        setSelectedSubTopicDetails(
          subtopics?.find(
            (subtopic) =>
              subtopic?.isChapterEndAssessment === true &&
              subtopic?.isProficient === true
          )
        );
        setIsProficientChapterEndAssessment(true);
      }
    } else if (subTopicType === "customAssessment") {
      setSelectedSubTopicDetails(
        subtopics?.find((subtopic) => subtopic?.isCustomAssessment === true)
      );
    } else if (subTopicType === "Prerequisite") {
      setSelectedSubTopicDetails(
        subtopics?.find((subtopic) =>
          isNotEmptyOrNull(subtopic?.learnPrerequisite)
        )
      );
    }
  };

  useEffect(() => {
    if (selectedSubtopic && isUpdatesDisplayed) {
      let subtopicId = selectedSubtopic?.subtopicId;

      setUpdatesSubtopicId(subtopicId);

      let accordionType = onClickSubtopic(
        !selectedSubtopic?.locked,
        false,
        false,
        false
      );
      // console.log("ACCORDION TYPE", accordionType);
      if (isNotEmptyOrNull(accordionType) && isNotEmptyOrNull(subtopics)) {
        handleAccordionToggle(subtopicId, accordionType, false, false);
      }

      handleTaskProgressData(
        topics?.topic?.topicId,
        subtopicId,
        10,
        0,
        false,
        false,
        false,
        false
      );
    }
  }, [selectedSubtopic, subtopics]);

  //console.log("Subtopics2", subtopics); // need for future purpose
  return (
    <Box sx={SubjectSelectorStyles(isSideNav, "").mainContainer}>
      <VStack sx={SubjectSelectorStyles(isSideNav, "").subtopicContainer}>
        {subtopics?.map((topic, index) => {
          if (isNotEmptyOrNull(topic)) {
            //console.log("TOPIC ITEM", topic); //Need this for future purpose
            let isunlocked =
              topic?.locked === false ? true : isTutor ? true : false;
            let isChapterEndAssessment = topic?.isChapterEndAssessment;
            let isExperientialLearning = topic?.isExperiential;
            let isExperientialTask = topic?.isTaskCreated;
            let isAdvanced = topic?.isAdvanced;
            let isProficient = topic?.isProficient;
            let isPrerequisite = topic?.isPrerequisite;
            let isCustomAssessment = topic?.isCustomAssessment;

            let subtopicTitle = isChapterEndAssessment
              ? isAdvanced
                ? "Chapter End Practice (Advanced)"
                : "Chapter End Practice (Proficient)"
              : isExperientialLearning
              ? topic?.title
              : isCustomAssessment
              ? "Assessments on multi-subtopic"
              : isPrerequisite
              ? "Prerequisite"
              : topic?.subtopicInfo?.name
              ? topic?.subtopicInfo?.name
              : topic?.name;

            let subtopicId = isExperientialLearning
              ? topic?.id
              : isChapterEndAssessment
              ? topics?.topic?.topicId
              : isPrerequisite
              ? `${topics?.topic?.topicId}-prerequisite`
              : topic?.subtopicId
              ? topic?.subtopicId
              : topic?.id;

            let isNormal = isChapterEndAssessment
              ? true
              : isExperientialLearning
              ? false
              : isExperientialTask
              ? false
              : isCustomAssessment
              ? false
              : true;

            return (
              <Box
                sx={SubjectSelectorStyles(isSideNav, isunlocked).subtopicBox}
                id={`subtopic-${index}`}
              >
                <Flex
                  key={subtopicId + 1}
                  sx={
                    SubjectSelectorStyles(
                      isSideNav,
                      isunlocked,
                      selectedSubtopic,
                      topic
                    ).subtopicHeaderBox
                  }
                  onClick={() => {
                    if (!isTutor) {
                      setIsUpdatesDisplayed(false);
                      setUpdatesSubtopicId(null);

                      //FOR DIFFERENT TYPE OF SUBTOPIC
                      const accordionType = onClickSubtopic(
                        isunlocked,
                        isExperientialLearning,
                        isChapterEndAssessment,
                        isCustomAssessment,
                        isPrerequisite
                      );
                      if (accordionType) {
                        handleAccordionToggle(
                          subtopicId,
                          accordionType,
                          isAdvanced,
                          isProficient
                        );
                      }
                      //CALLING THE TASK PROGRESS API
                      triggerTaskProgressData(
                        isunlocked,
                        isExperientialLearning,
                        isChapterEndAssessment,
                        isCustomAssessment,
                        subtopicId,
                        isAdvanced,
                        isProficient,
                        isPrerequisite
                      );
                    }
                    if (selectedIndex === 3) {
                      setSelectedSubTopicDetails(topic);
                      onClick("Self Learn");
                    }
                  }}
                >
                  {selectedIndex !== 2 &&
                    selectedIndex !== 3 &&
                    !isCustomAssessment && (
                      <Flex
                        sx={
                          SubjectSelectorStyles(isSideNav, isunlocked)
                            .progressStatusIcon
                        }
                      >
                        <ProgressStatus
                          status={isunlocked}
                          progress={latestTasksList}
                          subTopicId={subtopicId}
                          isNormal={isNormal}
                          isSideNav={isSideNav}
                        />
                      </Flex>
                    )}
                  <Wrap
                    sx={
                      SubjectSelectorStyles(isSideNav, isunlocked)
                        .subtopicTitleBox
                    }
                  >
                    <WrapItem>
                      <Text
                        sx={
                          SubjectSelectorStyles(isSideNav, isunlocked)
                            .subtopicTitle
                        }
                      >
                        {subtopicTitle || <Skeleton count={1} />}
                      </Text>
                    </WrapItem>
                  </Wrap>
                </Flex>

                {showAccordionSubtopicContent(
                  updatesSubtopicId,
                  openSubtopicId,
                  subtopicId,
                  isChapterEndAssessment,
                  isAdvanced,
                  isAdvancedChapterEndAssessment,
                  isProficient,
                  isProficientChapterEndAssessment,
                  isUpdatesDisplayed
                ) && (
                  <>
                    <Box
                      sx={
                        SubjectSelectorStyles(isSideNav, "", "", "", isMobile)
                          .taskListBox
                      }
                    >
                      {/* PROGRESS ITEMS  */}
                      <Box
                        sx={
                          SubjectSelectorStyles(isSideNav, "", "", "", isMobile)
                            .progressItems
                        }
                      >
                        {/* BULLET LIST */}
                        <ListAccordionView
                          isExperientialLearning={isExperientialLearning}
                          isCustomAssessment={isCustomAssessment}
                          subTopicTaskProgress={subTopicTaskProgress}
                          isMobile={isMobile}
                          isSideNav={isSideNav}
                        />

                        <Box marginLeft="8px" width={"100%"}>
                          {/* EXPERIENTIAL LEARNING */}
                          <ExperientialAccordion
                            isExperientialLearning={isExperientialLearning}
                            isCustomAssessment={isCustomAssessment}
                            isChapterEndAssessment={isChapterEndAssessment}
                            isExperientialTask={isExperientialTask}
                            isMobile={isMobile}
                            onClick={onClick}
                          />
                          {/* NORMAL TASKS AND CHAPTER END ASSESSMENT */}
                          {!isExperientialLearning &&
                            !isCustomAssessment &&
                            (isLoading ? (
                              <AccordionTaskSkeleton
                                size={subTopicTaskProgress?.length}
                                isMobile={isMobile || isSideNav}
                              />
                            ) : (
                              <SubtopicsAccordion
                                subTopicTaskProgress={subTopicTaskProgress}
                                isCustomAssessment={isCustomAssessment}
                                isExperientialLearning={isExperientialLearning}
                                isChapterEndAssessment={isChapterEndAssessment}
                                isPrerequisite={isPrerequisite}
                                isMobile={isMobile}
                                onClick={onClick}
                                isSideNav={isSideNav}
                                setTaskType={setTaskType}
                                isAdvanced={isAdvanced}
                                isProficient={isProficient}
                              />
                            ))}

                          {/* CUSTOM ASSESSMENT */}
                          {!isExperientialLearning &&
                            !isChapterEndAssessment &&
                            !isPrerequisite &&
                            isCustomAssessment &&
                            (isLoading ? (
                              <AccordionTaskSkeleton
                                size={subTopicTaskProgress?.length}
                                isMobile={isMobile || isSideNav}
                              />
                            ) : (
                              <CustomAssessmentAccordion
                                subTopicTaskProgress={subTopicTaskProgress}
                                setTaskType={setTaskType}
                                onClick={onClick}
                                isChapterEndAssessment={isChapterEndAssessment}
                              />
                            ))}
                        </Box>
                      </Box>

                      {/* SELF LEARN BUTTONS */}
                      {!isSideNav &&
                        !isExperientialLearning &&
                        !isCustomAssessment && (
                          <SelfLearnButtonsAccordion
                            isMobile={isMobile}
                            setTaskType={setTaskType}
                            onClick={onClick}
                            topic_feature={
                              topics?.topic?.topicInfo?.topic_features
                            }
                            isChapterEndAssessment={isChapterEndAssessment}
                            isAdvanced={isAdvanced}
                            isProficient={isProficient}
                            isPrerequisite={isPrerequisite}
                          />
                        )}
                    </Box>
                  </>
                )}
                <Box
                  sx={
                    SubjectSelectorStyles(isSideNav, "", "", "", isMobile)
                      .bottomLine
                  }
                />
              </Box>
            );
          }
        })}
      </VStack>
      {/* ASK YOUR DOUBT */}
      {isSideNav && <AskDoubtAccordion topics={topics} isSideNav={isSideNav} />}
    </Box>
  );
};

export default SubjectSelector;
